module.exports = __webpack_public_path__ + "img/close.f2b97334.svg";